import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceRequestPaymentInputContComponent } from './service-request-payment-input-cont.component';
import { RouterModule } from '@angular/router';
import { ServiceRequestPaymentInputPresModule } from '../presenter/service-request-payment-input-pres.module';
import { PaymentTermsModule } from '@app/service-request-payment-input/sub-components/modal/payment-terms/payment-terms.module';
import { ModalServiceModule } from '@lib/services';
import { PasswordInputModule } from '@common/services/service-request-payment-input/password-input';
import { DialogConfirmModule } from '@common/components/info-dialog/info-dialog.module';
import { ServiceRequestPaymentInputContGuard } from './service-request-payment-input-cont.guard';

@NgModule({
  declarations: [ServiceRequestPaymentInputContComponent],
  providers: [ServiceRequestPaymentInputContGuard],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ServiceRequestPaymentInputContComponent,
        canDeactivate: [ServiceRequestPaymentInputContGuard],
      },
    ]),
    CommonModule,
    ServiceRequestPaymentInputPresModule,
    PasswordInputModule,
    PaymentTermsModule,
    ModalServiceModule,
    DialogConfirmModule,
  ],
  exports: [ServiceRequestPaymentInputContComponent],
})
export class ServiceRequestPaymentInputContModule {}
